module.exports = __webpack_public_path__ + "static/media/400097_01.1cf82cba.png";